import { render, staticRenderFns } from "./add-block.vue?vue&type=template&id=69a5d062&scoped=true"
import script from "./add-block.vue?vue&type=script&lang=js"
export * from "./add-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a5d062",
  null
  
)

export default component.exports